import { useEffect, useState } from "react";

export function usePagination(apiPromise, data = null, initialLoad = true) {  
  const [response, setResponse] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [meta, setMeta] = useState({
    page: 1,
    payload: data,
    initialLoad,
  });
  const [limit, setPerPage] = useState(10);
  const [totalItems, settotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    if (meta.initialLoad) {
      setLoading(true);
      setResponse([]);
      apiPromise(meta.payload, { page: meta.page, limit })
        .then((res) => {
          // console.log(res,"jijijijijjiji");
          
          if (res) {
            setResponse(res.data);
          } else {
            setResponse({});
          }

          settotalItems(res?.data?.pageInfo?.totalItems || 0);
          setTotalPages(res?.data?.pageInfo?.totalPages || 1);
          setLoading(false);
        })
        .catch((err) => {
          const response = err.response;
          if (response) {
            setError(response.data.errors ? response.data.errors[0] : response.data.message);
          }
          setLoading(false);
        });
    }
  }, [meta, limit]);

  const setMetaKey = (key, value) => {
    setMeta((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return {
    response,
    loading,
    error,
    setPage: (x) => {
      setMeta({ ...meta, page: x });
    },
    page: meta.page,
    setPerPage,
    totalItems,
    totalPages,
    setPayload: (x) => {
      setMeta({ ...meta, payload: x });
    },
    setMeta,
    setMetaKey,
    meta,
  };
}
